import clsx from 'clsx';

// Components
import Checkbox from '@/components/base/Checkbox';

// Types
import type { OptionType } from '@/components/base/Select';

type DefaultOptionProps = {
    option?: OptionType;
    selected?: boolean;
    disabled?: boolean;
    forcedDisplay?: boolean;
    isTruncate?: boolean;
    isMultiple?: boolean;
};

const DefaultOption = ({
    option,
    selected,
    disabled,
    forcedDisplay,
    isTruncate = true,
    isMultiple = false
}: DefaultOptionProps) => {
    return (
        <div
            className={clsx('focus inset-y-0 block', {
                'font-GBold text-icoBlue': selected && !isMultiple,
                'font-GSemiBold': !selected || isMultiple,
                'text-icoBlack dark:text-white': isMultiple,
                'text-icoGray-400':
                    disabled ||
                    ((option?.value === null ||
                        option?.value === '' ||
                        option?.value === undefined) &&
                        !selected &&
                        !forcedDisplay),
                truncate: isTruncate
            })}>
            {isMultiple ? (
                <span className="flex min-w-full items-center space-x-4">
                    <Checkbox
                        checked={selected}
                        onChange={() => {
                            // Do nothing needed to prevent console error on checkbox
                        }}
                    />
                    <span title={option?.label}>{option?.label}</span>
                </span>
            ) : (
                <span title={option?.label}>{option?.label}</span>
            )}
        </div>
    );
};

export default DefaultOption;
